const AlertState = ({ state, showLabel = true }) =>
  state ? (
    <div className="alert-state">
      {showLabel ? <span className="state-label">Current State:</span> : null}
      <span className={`state-text ${state}`}>{state}</span>
    </div>
  ) : null;

export default AlertState;
